import src from "IMAGE";
export default { src, width: 369, height: 369, blurWidth: 0, blurHeight: 0};
